module.exports = __webpack_public_path__ + "d75ae01adb90d8bcff002b09b5edce7c.svg";